import React, { Component } from "react";
import NavDropdown from "reactstrap/lib/NavDropdown";
import DropdownMenu from "reactstrap/lib/DropdownMenu";
import DropdownToggle from "reactstrap/lib/DropdownToggle";
import DropdownItem from "reactstrap/lib/DropdownItem";
import { Link } from "react-router-dom";

import styles from "./Navigation.css";

class NavigationDropdown extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    if (!this.props.items || this.props.items.length === 0) return null;
    const name = this.props.name.replace(" ", "-").toLowerCase();
    if (this.props.isMobile)
      return (
        <div>
          <div className={styles.mobileSectionHeader}>
            {this.props.name}
          </div>
          <div className={styles.mobileList}>
            {this.props.items.map((item, index) => {
              const key = item.id || `${item.url}-${index}`;
              if (!item.url) {
                return (
                  <button
                    key={key}
                    onClick={(event) => {
                      this.props.mobileToggle();
                      item.onClick(event);
                    }}
                    className={styles.buttonItem}>{item.name}</button>
                );
              } else if (item.internal || item.url.indexOf("https://www.axios.com") >= 0) {
                return (
                  <Link
                    key={key}
                    onClick={this.props.mobileToggle}
                    to={item.url.replace("https://www.axios.com", "")}
                    className={styles.item}>{item.name}</Link>
                );
              } else {
                return <a key={key} href={item.url} className={styles.item}>{item.name}</a>;
              }
            })}
          </div>
        </div>
      );

    return (
      <NavDropdown isOpen={this.state.isOpen} toggle={this.toggle}>
        <DropdownToggle id={`${name}-toggle`} nav caret={!this.props.toggle} className={styles.toggle}>
          {this.props.toggle || this.props.name}
        </DropdownToggle>
        <DropdownMenu id={`${name}-menu`} className={styles.menu} aria-labelledby={`${name}-toggle`}>
          {this.props.items.map((item, index) => {
            const key = item.id || `${item.url}-${index}`;
            if (!item.url) {
              return (
                <button
                  key={key}
                  role="menuitem"
                  tabIndex="0"
                  onClick={(event) => {
                    this.toggle();
                    item.onClick(event);
                  }}
                  className={styles.buttonItem}>{item.name}</button>
              );
            } else if (item.internal || item.url.indexOf("https://www.axios.com") >= 0) {
              return (
                <Link
                  key={key}
                  role="menuitem"
                  to={item.url.replace("https://www.axios.com", "")}
                  onClick={this.toggle}
                  className={styles.item}>{item.name}</Link>
              );
            } else {
              return (
                <DropdownItem
                  key={item.id || `${item.url}-${index}`}
                  role="menuitem"
                  href={item.url}
                  onClick={item.onClick}
                  className={styles.item}>
                  {item.name}
                </DropdownItem>
              );
            }

          })}
        </DropdownMenu>
      </NavDropdown>
    );
  }
}

export default NavigationDropdown;



// WEBPACK FOOTER //
// ./src/components/Library/Navigation/NavigationDropdown.js